module.exports = __webpack_public_path__ + "images/882283ef3c7a052f6b3e9c541c37279a.png";